import type { CSSProperties, FC } from "react"

interface Props {
  className?: string
  style?: CSSProperties
}

const Location: FC<Props> = ({ className, style }) => {
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g clipPath="url(#clip0_22_532)">
        <path
          fill="currentColor"
          d="M10 1.25C8.17732 1.25222 6.42993 1.97726 5.1411 3.26609C3.85226 4.55492 3.12722 6.30232 3.12501 8.125C3.12285 9.61454 3.60947 11.0636 4.51019 12.25C4.51019 12.25 4.69769 12.4966 4.72782 12.5323L10 18.75L15.2744 12.5296C15.3021 12.4963 15.4898 12.2498 15.4898 12.2498L15.4908 12.2483C16.3909 11.0623 16.8772 9.61386 16.875 8.125C16.8728 6.30232 16.1478 4.55492 14.8589 3.26609C13.5701 1.97726 11.8227 1.25222 10 1.25ZM10 10.625C9.50555 10.625 9.02221 10.4784 8.61108 10.2037C8.19996 9.92897 7.87953 9.53852 7.69031 9.08171C7.50109 8.62489 7.45158 8.12223 7.54804 7.63727C7.64451 7.15232 7.88261 6.70686 8.23224 6.35723C8.58187 6.0076 9.02733 5.7695 9.51228 5.67304C9.99723 5.57657 10.4999 5.62608 10.9567 5.8153C11.4135 6.00452 11.804 6.32495 12.0787 6.73607C12.3534 7.1472 12.5 7.63055 12.5 8.125C12.4993 8.78781 12.2356 9.42326 11.767 9.89194C11.2983 10.3606 10.6628 10.6243 10 10.625Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_22_532">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Location
